import { useSgBsTheme } from 'hooks/useSgBsTheme';
import { FC } from 'react';
import type { GroupColor } from 'state/quotes/dashboard/tiles/tiles.model';
import styled from 'styled-components';

import { mapColorToVariable } from './color';

export const StyledEm = styled.em<{ $colorVar: string }>`
  color: ${props => props.$colorVar};
`;

type IconProps = {
  iconName: string;
  color: GroupColor | undefined;
};

export const GroupColoredIcon: FC<IconProps> = ({ iconName, color }) => {
  const theme = useSgBsTheme();
  const colorVar = color !== undefined ? mapColorToVariable(theme, color) : 'inherited';

  return (
    <StyledEm className="icon icon-md" $colorVar={colorVar}>
      {iconName}
    </StyledEm>
  );
};
